import { modifyState } from '~src/state';

export const checkShouldCreateCanvas = () => {
  const projectTypeId = window.urlParams.get('tipo');
  const idFormato = window.urlParams.get('formato');
  const idServizio = window.urlParams.get('servizio');

  return projectTypeId && idFormato && idServizio;
};

export const readTipoFromQueryString = (projects = { items: [] }) => {
  const projectTypeId = window.urlParams.get('tipo');

  if (projectTypeId && projectTypeId !== 'undefined') {
    const project = projects.items.find(
      (project) => project.objectId === projectTypeId
    );

    if (project) {
      modifyState('selected.tipo', project);

      return true;
    }
  }

  window.urlParams.delete('tipo');
  window.urlParams.delete('code');
  window.urlParams.delete('state');

  window.history.replaceState(
    {},
    '',
    `${window.location.href.split('?')[0]}?` + window.urlParams
  );

  return false;
};

export const readFormatoFromQueryString = ({ formats }) => {
  const idFormato = window.urlParams.get('formato');

  if (idFormato && idFormato !== 'undefined') {
    const format = formats.items.find(
      (format) => format.objectId === idFormato
    );

    if (format) {
      modifyState('selected.formato', format);
      modifyState(
        'selected.formatoDefault',
        format.editor_project_formats_default_pointer
      );

      return true;
    }
  }

  window.urlParams.delete('formato');

  window.history.replaceState(
    {},
    '',
    `${window.location.href.split('?')[0]}?` + window.urlParams
  );

  return false;
};
